var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerGasProducerUnitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#1E124A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000, 25.000) scale(0.025000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.58-96Q276-96 234-138t-42-102v-336q0-47 25.5-83.5T288-711v-81q0-29.7 21.15-50.85Q330.3-864 360-864h240q29.7 0 50.85 21.15Q672-821.7 672-792v81q45 15 70.5 51.5T768-576v336q0 60-42 102T624.42-96H335.58ZM264-444h432v-132q0-29.7-21.17-50.85Q653.67-648 623.94-648H335.72Q306-648 285-626.85T264-576v132Zm72.06 276h288.22Q654-168 675-189.15T696-240v-132H264v132q0 29.7 21.17 50.85Q306.33-168 336.06-168ZM480-444Zm0 72Zm0-36Zm36-312h84v-72H360v72h84q0-15 10.29-25.5t25.5-10.5q15.21 0 25.71 10.35T516-720Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerGasProducerUnitIcon);
export default __webpack_public_path__ + "static/media/marker-gasProducerUnit-icon.7859676f0b7de1f65328fbdc9dea9cba.svg";
export { ForwardRef as ReactComponent };